export { default } from './Affix.js';
